"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePeopleListingCard = exports.PeopleListingCard = void 0;
var mobilePeopleListingStyles = require("@/pages/peopleListing/components/PeopleListingCard/PeopleListingCard.mobile.styles");
var peopleListingStyles = require("@/pages/peopleListing/components/PeopleListingCard/PeopleListingCard.styles");
var PeopleListingCard_styles_1 = require("@/pages/peopleListing/components/PeopleListingCard/PeopleListingCard.styles");
var React = require("react");
var getPeopleListingCard = function (styledComponent) {
    var PeopleContainer = styledComponent.PeopleContainer, PeopleImageContainer = styledComponent.PeopleImageContainer, PeopleNameText = styledComponent.PeopleNameText;
    return function (props) {
        var peopleImageUrl = props.peopleImageUrl, peopleName = props.peopleName, peopleCaption = props.peopleCaption, peopleUrl = props.peopleUrl;
        return (React.createElement(PeopleContainer, { href: peopleUrl },
            React.createElement(PeopleImageContainer, { style: { backgroundImage: "url(" + peopleImageUrl + ")" } }),
            React.createElement(PeopleNameText, null, peopleName),
            peopleCaption ? (React.createElement(PeopleListingCard_styles_1.PeopleNameCaption, null, peopleCaption)) : null));
    };
};
var PeopleListingCard = getPeopleListingCard(peopleListingStyles);
exports.PeopleListingCard = PeopleListingCard;
var MobilePeopleListingCard = getPeopleListingCard(mobilePeopleListingStyles);
exports.MobilePeopleListingCard = MobilePeopleListingCard;
